"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepIndicator = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
require("./stepIndicator.css");
var StepIndicator = /** @class */ (function (_super) {
    __extends(StepIndicator, _super);
    function StepIndicator(props) {
        var _this = _super.call(this, props) || this;
        _this.renderSteps = function () {
            return Array.from(Array(_this.props.total).keys()).map(function (stepIndex) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('step-container', stepIndex + 1 <= _this.props.done ? 'step-container-done' : '', stepIndex === _this.props.done ? 'step-container-doing' : '', stepIndex > _this.props.done ? 'step-container-todo' : '') }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "step-disc" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "step-content" }, { children: stepIndex >= _this.props.done ? stepIndex + 1 : '' })) })) }), stepIndex)); });
        };
        return _this;
    }
    StepIndicator.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)("div", __assign({ className: "step-indicator" }, { children: this.renderSteps() }));
    };
    return StepIndicator;
}(react_1.default.PureComponent));
exports.StepIndicator = StepIndicator;
//# sourceMappingURL=StepIndicator.js.map